var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex-column dropdown-search dropdown-search-third" },
    [
      _c(
        "el-dropdown",
        { attrs: { trigger: "click" }, on: { command: _vm.update } },
        [
          _c("el-input", {
            staticClass: "wp-10",
            attrs: {
              "data-bot": _vm.getDatabot(
                "name",
                _vm.currentStore,
                null,
                _vm.third
              ),
              placeholder: _vm.placeholder
            },
            on: {
              input: function($event) {
                return _vm.searchThird(_vm.defaultValue)
              }
            },
            model: {
              value: _vm.defaultValue,
              callback: function($$v) {
                _vm.defaultValue = $$v
              },
              expression: "defaultValue"
            }
          }),
          _vm._v(" "),
          _c(
            "el-dropdown-menu",
            {
              staticClass: "p-2 dropdown-search-third__list",
              class: { hide: !_vm.hasQuery && _vm.searchDisabled },
              attrs: {
                slot: "dropdown",
                placement: "bottom",
                "data-bot": _vm.getDatabot(
                  "name-popup",
                  _vm.currentStore,
                  null,
                  _vm.third
                )
              },
              slot: "dropdown"
            },
            [
              _c("preloader", {
                staticClass: "loader-small",
                attrs: { display: _vm.loading }
              }),
              _vm._v(" "),
              !_vm.err && !_vm.loading
                ? _c(
                    "div",
                    {
                      staticClass: "prelative dropdown-search-third__items",
                      class: { "pt-2": _vm.hasItems && _vm.hasQuery }
                    },
                    [
                      _vm.hasItems && _vm.hasQuery
                        ? _c("span", { staticClass: "gray-80 fs-2 lh-20" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$l10n.__(
                                  "Société(s) déjà existante(s) dans le répertoire de société"
                                )
                              )
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.result, function(item, index) {
                        return _c(
                          "el-dropdown-item",
                          {
                            key: index,
                            staticClass: "gray-100",
                            attrs: { command: item }
                          },
                          [
                            _c("form-fields-companies-list", {
                              staticClass: "py-2 dropdown-search-third__item",
                              attrs: {
                                company: item,
                                enabled: true,
                                third: _vm.third,
                                allowBadge: ""
                              }
                            })
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { class: { "bt-1": _vm.hasItems && _vm.hasQuery } },
                [
                  !_vm.searchDisabled
                    ? _c(
                        "el-dropdown-item",
                        {
                          staticClass: "not-item ln-20 flex-row my-0",
                          class: { "mt-2": !_vm.searchDisabled && _vm.hasItems }
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "fs-3 px-2 ln-20 mr-2 semibold link",
                              attrs: {
                                href: "javascript:;",
                                "data-bot": _vm.getDatabot(
                                  "name-popup",
                                  _vm.currentStore,
                                  null,
                                  _vm.third
                                )
                              },
                              on: {
                                click: function($event) {
                                  return _vm.openSearchThirdPopUp()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$l10n.__(
                                      "Rechercher une nouvelle société"
                                    )
                                  ) +
                                  "\n                    "
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasQuery
                    ? _c(
                        "el-dropdown-item",
                        { staticClass: "mb-0 not-item ln-20" },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "fs-3 px-2 ln-20 mr-2 semibold link",
                              attrs: {
                                href: "javascript:;",
                                "data-bot": _vm.getDatabot(
                                  "name-popup-add-new",
                                  _vm.currentStore,
                                  null,
                                  _vm.third
                                )
                              },
                              on: {
                                click: function($event) {
                                  return _vm.openCreateThirdPopUp(
                                    _vm.third,
                                    "prospect"
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.thirdType) +
                                  "\n                    "
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }